import { render, staticRenderFns } from "./homebottom6.vue?vue&type=template&id=372ce563&scoped=true"
import script from "./homebottom6.vue?vue&type=script&lang=js"
export * from "./homebottom6.vue?vue&type=script&lang=js"
import style0 from "./homebottom6.vue?vue&type=style&index=0&id=372ce563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372ce563",
  null
  
)

export default component.exports